(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fd-season-search"]) return;
  try {
    
(function () {
  function start(container) {
    (container || document).querySelectorAll('[data-fdss]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var grid = root.querySelector('[data-fdss-grid]');
      var status = root.querySelector('[data-fdss-status]');
      var more = root.querySelector('[data-fdss-more]');
      var retry = root.querySelector('[data-fdss-retry]');
      var select = root.querySelector('[data-fdss-sort]');
      var base = new URL(location.href);
      base.searchParams.set('type', 'product');
      base.searchParams.set('section_id', root.dataset.section);
      base.searchParams.delete('page');
      var originalQuery = base.searchParams.get('q') || '';
      var pageBrand = document.title.split('–').pop().trim();
      if (originalQuery && !/[:"()]/.test(originalQuery) && !/\b(?:AND|OR|NOT)\b/.test(originalQuery)) {
        base.searchParams.set('q', originalQuery.trim().split(/\s+/).map(function (word) {
          return 'title:"' + word.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
        }).join(' AND '));
      }
      var mode = base.searchParams.get('sort_by');
      if (mode !== 'price-ascending' && mode !== 'price-descending') {
        mode = 'season'; base.searchParams.delete('sort_by');
      }
      select.value = mode;
      var items = [], shown = 0, currency = 'EUR', loading = false;
      function season(score) {
        var year = Math.floor(Number(score) / 10), span = Number(score) % 10;
        if (!year) return '';
        return span ? year + '/' + String((year + span) % 100).padStart(2, '0') : String(year);
      }
      function append(n) {
        var fragment = document.createDocumentFragment();
        var money = new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: currency });
        for (var i = 0; i < n && shown < items.length; i++, shown++) {
          var item = items[shown];
          fragment.appendChild(window.FDProductCards.create(item, {className:'fdss-card', currency:currency}));
        }
        grid.appendChild(fragment); more.hidden = shown >= items.length;
      }
      function render() {
        var sort = select.value;
        items.sort(function (a, b) {
          var price = sort === 'price-ascending' ? a.price - b.price : sort === 'price-descending' ? b.price - a.price : 0;
          return price || (Number(b.score) || 0) - (Number(a.score) || 0) || a.title.localeCompare(b.title, 'fr', { numeric: true }) || Number(a.id) - Number(b.id);
        });
        shown = 0; grid.replaceChildren(); append(24);
      }
      async function page(n) {
        var url = new URL(base); url.searchParams.set('page', n);
        for (var attempt = 0; attempt < 2; attempt++) {
          try {
            var response = await fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
            if (!response.ok) throw new Error('search response');
            var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            var payload = doc.querySelector('[data-fdss-json]');
            if (!payload) throw new Error('search payload');
            return JSON.parse(payload.textContent);
          } catch (error) { if (attempt) throw error; }
        }
      }
      async function load() {
        if (loading) return;
        loading = true; root.setAttribute('aria-busy', 'true'); retry.hidden = true; more.hidden = true; status.textContent = 'Recherche des articles…';
        try {
          var first = await page(1);
          if (!(first.items || []).length && base.searchParams.get('q') !== originalQuery) {
            base.searchParams.set('q', originalQuery); first = await page(1);
          }
          var pages = Number(first.pages) || 1, next = 2;
          currency = first.currency || 'EUR'; var all = first.items || [];
          await Promise.all(Array.from({ length: Math.min(3, Math.max(0, pages - 1)) }, async function () {
            while (next <= pages) { var n = next++; var data = await page(n); all = all.concat(data.items || []); }
          }));
          var unique = new Map(); all.forEach(function (item) { unique.set(String(item.id), item); }); items = Array.from(unique.values());
          status.textContent = items.length ? items.length + ' article' + (items.length > 1 ? 's' : '') : 'Aucun article trouvé. Essayez un club, un pays ou une saison.';
          document.title = 'Recherche : ' + items.length + ' résultats pour « ' + originalQuery + ' » – ' + pageBrand;
          render();
        } catch (error) {
          status.textContent = 'La recherche n’a pas pu se terminer. Réessayez dans un instant.'; retry.hidden = false;
        } finally { loading = false; root.setAttribute('aria-busy', 'false'); }
      }
      select.addEventListener('change', function () {
        var url = new URL(location.href); url.searchParams.delete('page');
        if (select.value === 'season') url.searchParams.delete('sort_by'); else url.searchParams.set('sort_by', select.value);
        history.replaceState(null, '', url); if (items.length) render();
      });
      root.querySelectorAll('[data-fdss-price-form]').forEach(function (form) {
        form.addEventListener('submit', function () { form.elements.sort_by.value = select.value === 'season' ? '' : select.value; });
      });
      more.addEventListener('click', function () { append(24); }); retry.addEventListener('click', load); load();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(document); }, { once: true }); else start(document);
  document.addEventListener('shopify:section:load', function (event) { start(event.target.parentNode || document); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
